import moment from 'moment-timezone';
import qs from 'qs';

// eslint-disable-next-line import/prefer-default-export
export function getCurrentDate(location) {
  console.log('getCurrentDate called:', {
    location: location?.pathname,
    search: location?.search,
  });

  if (!location || !location.search) {
    const defaultDate = moment()
      .startOf('hour')
      .toISOString();
    console.log('getCurrentDate returning default:', defaultDate);
    return defaultDate;
  }

  const parsedSearch = qs.parse(location.search.substr(1));
  const extractedDate =
    parsedSearch.date ||
    moment()
      .startOf('hour')
      .toISOString();

  console.log('getCurrentDate parsed:', {
    search: location.search,
    parsedSearch,
    extractedDate,
  });

  return extractedDate;
}
